import { ThinLayout } from 'src/ui/shared/components/layout/ThinLayout';
import { PublicIdentityRouter } from '../identity/AuthenticationRouteList';

export const IdentityRouteLayout = () => (
    <ThinLayout>
        <PublicIdentityRouter />
    </ThinLayout>
);
